import React from 'react';
import MemberHeader from './MemberHeader';
import Footer from './Footer';
import './MemberLayout.scss';

const MemberLayout = ({ children }) => {
  return (
    <div className="member-layout">
      <MemberHeader />
      <main className="member-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MemberLayout;
